import { useState } from "react";
import { ListItem } from "@remo-co/ui-core/src/components/ListItem";
import { ListItemSecondaryAction } from "@remo-co/ui-core/src/components/ListItemSecondaryAction";
import { ListItemText } from "@remo-co/ui-core/src/components/ListItemText";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { ChevronRight } from "@remo-co/ui-core/src/icons/ChevronRight";
import { XCircle as XCircleIcon } from "@remo-co/ui-core/src/icons/XCircle";
import { useI18n } from "i18n";
import logger from "logging/logger";

import { useCompanyPlanSettings } from "modules/companyPlanSettings";
import { hasGuestPrice } from "modules/companyPlanSettings/utils/guestPlans";
import { ISubscriptionDetail } from "types/subscription";
import { useStyles } from "../../styles";
import { CancelSubscription } from "../CancelSubscription";

interface CancelSubscriptionListItemProps {
  subscriptionDetail?: ISubscriptionDetail;
  refreshSubscriptionInfo: () => void;
}
const CancelSubscriptionListItem = ({
  subscriptionDetail,
  refreshSubscriptionInfo,
}: CancelSubscriptionListItemProps): JSX.Element | null => {
  const { myCompanyPlan } = useCompanyPlanSettings();
  const styles = useStyles();
  const { t } = useI18n(["settings"]);
  const [isCancelSubscriptionOpen, setIsCancelSubscriptionOpen] =
    useState<boolean>(false);

  const handleSubscriptionCancellation = () => {
    logger.info(
      `[handleSubscriptionCancellation] opening cancel screen for ${subscriptionDetail?.subscription?.id}`,
    );
    setIsCancelSubscriptionOpen(true);
  };

  const handleCancelSubscriptionClose = (
    shouldRefreshSubscriptionInfo: boolean,
  ) => {
    setIsCancelSubscriptionOpen(false);

    if (shouldRefreshSubscriptionInfo) {
      refreshSubscriptionInfo();
    }
  };

  // Dont show cancellation if new pricing plan
  if (hasGuestPrice(myCompanyPlan)) {
    return null;
  }

  if (
    subscriptionDetail?.subscription?.id &&
    subscriptionDetail?.subscription?.status === "active"
  ) {
    return (
      <>
        <ListItem
          className={styles.billingListItem}
          button
          onClick={handleSubscriptionCancellation}
          data-testid="cancel-subs-btn"
        >
          <XCircleIcon className={styles.icon} />
          <ListItemText>
            <Typography variant="h5">
              {t("settings:cancel.subscription")}
            </Typography>
          </ListItemText>
          <ListItemSecondaryAction className={styles.chevron}>
            <ChevronRight />
          </ListItemSecondaryAction>
        </ListItem>

        {isCancelSubscriptionOpen && (
          <CancelSubscription
            subscriptionDetail={subscriptionDetail}
            handleClose={handleCancelSubscriptionClose}
          />
        )}
      </>
    );
  }

  return null;
};

export default CancelSubscriptionListItem;
